/* Elibelinde product: variant buy box, cart add, gallery, tabs, sticky buy, film. */
(function () {
  if (window.__ebProduct) return;
  window.__ebProduct = true;

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function boot() {
    bindGalleries();
    bindBoxes();
    bindCartAdds();
    bindTabs();
    bindSticky();
    bindFilms();
  }

  function jumpGallery(mediaId, smooth) {
    if (!mediaId || String(mediaId) === '0') return;
    var stage = document.querySelector('[data-eb-gallery-stage]');
    if (!stage) return;
    var slide = stage.querySelector('[data-media-id="' + mediaId + '"]');
    if (!slide) return;
    stage.scrollTo({
      left: slide.offsetLeft,
      behavior: smooth && !reduced() ? 'smooth' : 'auto'
    });
    var root = stage.closest('[data-eb-gallery]');
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-eb-thumb]'), function (thumb) {
      if (thumb.getAttribute('data-media-id') === String(mediaId)) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }

  function bindBoxes() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-eb-box]'), function (root) {
      var dataEl = root.querySelector('[data-eb-box-data]');
      if (!dataEl) return;
      var variants = [];
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }
      if (!variants || !variants.length) return;

      var byId = {};
      variants.forEach(function (variant) {
        byId[String(variant.id)] = variant;
      });

      var seasonOpen = root.getAttribute('data-season-open') === 'true';
      var syncUrl = root.getAttribute('data-sync-url') === 'true';
      var syncSticky = root.getAttribute('data-sync-sticky') === 'true';
      var idInput = root.querySelector('[data-eb-id]');
      var priceEl = root.querySelector('[data-eb-price]');
      var perEl = root.querySelector('[data-eb-perkg]');
      var helperEl = root.querySelector('[data-eb-helper]');
      var qtyWrap = root.querySelector('[data-eb-qty-wrap]');
      var qtyInput = root.querySelector('[data-eb-qty-input]');
      var purchase = root.querySelector('[data-eb-purchase]');
      var addButton = root.querySelector('[data-eb-add-button]');
      var notify = root.querySelector('[data-eb-notify]');
      var preorder = root.querySelector('[data-eb-preorder]');
      var tagsInput = root.querySelector('[data-eb-tags]');
      var radios = root.querySelectorAll('[data-eb-variant]');

      function apply(variant, opts) {
        if (!variant) return;
        opts = opts || {};
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.priceLabel || '';
        if (perEl) perEl.textContent = variant.perKgLabel || '';
        if (helperEl) helperEl.textContent = variant.helper || '';
        if (tagsInput && variant.tags) tagsInput.value = variant.tags;
        var on = !!variant.available;
        if (qtyWrap) qtyWrap.hidden = !on;
        if (purchase) purchase.hidden = !on;
        if (addButton) addButton.disabled = !on;
        if (notify) notify.hidden = on;
        if (preorder) preorder.hidden = !(on && !seasonOpen);
        Array.prototype.forEach.call(radios, function (radio) {
          radio.checked = String(radio.value) === String(variant.id);
        });
        if (syncSticky) {
          var stickyPack = document.querySelector('[data-eb-sticky-pack]');
          var stickyPrice = document.querySelector('[data-eb-sticky-price]');
          var stickyGo = document.querySelector('[data-eb-sticky-go]');
          if (stickyPack) stickyPack.textContent = variant.packLabel || '';
          if (stickyPrice) stickyPrice.textContent = variant.priceLabel || '';
          if (stickyGo) {
            stickyGo.textContent = on ? 'Sepete ekle' : 'Haber ver';
          }
        }
        if (syncUrl && opts.push && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', String(variant.id));
          window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        }
        if (opts.gallery && !document.querySelector('[data-eb-slide][data-media-id="lead-a"]')) jumpGallery(variant.mediaId, true);
      }

      Array.prototype.forEach.call(radios, function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          apply(byId[String(radio.value)], { push: true, gallery: true });
        });
      });

      if (qtyInput) {
        var dec = root.querySelector('[data-eb-qty-dec]');
        var inc = root.querySelector('[data-eb-qty-inc]');
        function readQty() {
          var n = parseInt(qtyInput.value, 10);
          if (!n || n < 1) n = 1;
          return n;
        }
        if (dec) {
          dec.addEventListener('click', function () {
            qtyInput.value = String(Math.max(1, readQty() - 1));
          });
        }
        if (inc) {
          inc.addEventListener('click', function () {
            qtyInput.value = String(readQty() + 1);
          });
        }
      }

      var currentId = idInput ? String(idInput.value) : '';
      if (byId[currentId]) apply(byId[currentId], { push: false, gallery: false });
    });
  }

  function bindCartAdds() {
    var forms = document.querySelectorAll('form[data-eb-add]');
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        var box = form.closest('[data-eb-box]');
        if (box) {
          var purchase = box.querySelector('[data-eb-purchase]');
          if (purchase && purchase.hidden) {
            event.preventDefault();
            return;
          }
        }
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        var qty = form.querySelector('[name="quantity"]');
        if (qty) {
          var n = parseInt(qty.value, 10);
          if (!n || n < 1) qty.value = '1';
        }
        var button = form.querySelector('[type="submit"]');
        var errorEl = form.querySelector('[data-eb-add-error]');
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        }
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('eb:cart:updated', { detail: { open: true } }));
          })
          .catch(function (err) {
            var msg = 'Sepete eklenemedi. Lütfen yeniden deneyin.';
            if (err && (err.description || err.message)) msg = err.description || err.message;
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = msg;
            }
          })
          .then(function () {
            if (button) {
              button.disabled = false;
              button.removeAttribute('aria-busy');
            }
          });
      });
    });
  }

  function bindGalleries() {
    var reduce = reduced();
    Array.prototype.forEach.call(document.querySelectorAll('[data-eb-gallery]'), function (root) {
      var stage = root.querySelector('[data-eb-gallery-stage]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-eb-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-eb-thumb]'));
      if (!slides.length) return;

      function setCurrent(index) {
        thumbs.forEach(function (thumb, i) {
          if (i === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function (event) {
          if (!slides[i]) return;
          event.preventDefault();
          slides[i].scrollIntoView({
            behavior: reduce ? 'auto' : 'smooth',
            inline: 'start',
            block: 'nearest'
          });
          setCurrent(i);
        });
      });

      if (stage) {
        stage.addEventListener(
          'scroll',
          function () {
            var width = stage.clientWidth || 1;
            var index = Math.round(stage.scrollLeft / width);
            if (index < 0) index = 0;
            if (index > slides.length - 1) index = slides.length - 1;
            setCurrent(index);
          },
          { passive: true }
        );
        var initial = root.getAttribute('data-initial-media');
        if (initial && !root.querySelector('[data-media-id="lead-a"]')) {
          var slide = stage.querySelector('[data-media-id="' + initial + '"]');
          if (slide) stage.scrollLeft = slide.offsetLeft;
        }
      }
    });
  }

  function bindTabs() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-eb-tabs]'), function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length) return;

      function activate(index) {
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (panels[i]) panels[i].classList.toggle('is-open', on);
        });
      }

      var current = 0;
      tabs.forEach(function (tab, i) {
        if (tab.getAttribute('aria-selected') === 'true') current = i;
        tab.addEventListener('click', function () {
          activate(i);
        });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          if (next === null) return;
          event.preventDefault();
          activate(next);
          tabs[next].focus();
        });
      });

      root.classList.add('is-ready');
      activate(current);
    });
  }

  function bindSticky() {
    var anchor = document.querySelector('[data-eb-buy-anchor]');
    var bar = document.querySelector('[data-eb-sticky-buy]');
    if (!anchor || !bar || !('IntersectionObserver' in window)) return;
    var mobile = window.matchMedia('(max-width: 1099px)');

    function apply(visible) {
      var on = visible && mobile.matches;
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('eb-sticky-on', on);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        apply(!entry.isIntersecting);
      });
    });
    observer.observe(anchor);
    if (mobile.addEventListener) {
      mobile.addEventListener('change', function () {
        var rect = anchor.getBoundingClientRect();
        var seen = rect.bottom > 0 && rect.top < window.innerHeight;
        apply(!seen);
      });
    }
  }

  function bindFilms() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-eb-film]'), function (root) {
      var button = root.querySelector('[data-eb-film-play]');
      var video = root.querySelector('video');
      if (!button || !video) return;
      root.classList.add('is-ready');
      button.addEventListener('click', function () {
        button.hidden = true;
        video.classList.add('is-playing');
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
